/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Editor/Constants" />
export const enum EndpointsEditorPanelContentType {
    CreateForm = "CreateForm",
    EndpointAuthSchemes = "EndpointAuthSchemes",
    ServiceEndpointTypes = "ServiceEndpointTypes",
    UpdateForm = "UpdateForm"
}

export const enum ActionsCreatorInstanceIds {
    EndpointsEditorActionsCreatorInstanceId = "create-panel-action-creator",
    EndpointsEditorStoreInstanceId = "create-panel-store",
    IdentityTypeStoreInstanceId = "identity-type-store",
    CredentialTypeStoreInstanceId = "credential-type-store",
    NavigationActionsCreatorInstanceId = "endpoint-navigation-action-creator",
    EndpointSaveProgressStoreInstanceId = "save-progress-store",
}

export const enum EndpointOperationStatusState {
    InProgress = "inprogress",
    Failed = "failed"
}

export const enum VerificationStatus {
    InProgress = 1,
    Successful = 2,
    Failed = 3,
    NotClicked = 4
}

export module FeatureAvailabilityFlags {
    export const EnableMSIForACR = "ServiceEndpoints.EnableMSIForACR";
    export const EnableSovereignSupportInKubernetesEndpoint = "ServiceEndpoints.EnableSovereignSupport";
    export const EnablePublishProfileAuthSchemeInARMEndpoint = "ServiceEndpoints.EnablePublishProfileAuthSchemeInAzureRMEndpoint";
    export const EnableNewARMServiceEndpointType = "ServiceEndpoints.EnableNewARMServiceEndpointType";
}

export const ConfidentialInputPlaceHolder = "********";

export const TestConnectionDataSource = "TestConnection";

export const OAuthScheme = "OAuth";

export const OAuth2Scheme = "OAuth2";

export const TokenScheme = "Token";

export const PersonalAccessTokenScheme = "PersonalAccessToken";

export const AccessToken = "AccessToken";

export const InstallationToken = "InstallationToken";

export const GitHubUserNamePrefix = "github.com_";

export const BitBucketUserNamePrefix = "bitbucket_";

export const Username = "username";

export const Password = "password";

export const UsernamePassword = "UsernamePassword";

export const SSHURLPrefix = "ssh://";

export const SSHResultContentType = 1;

export const SSHMaximumSingleFileSize = 10240;

export const SSHmaximumNumberOfFiles = 1;

export const ConfigurationId = "ConfigurationId";

export const Provider = "provider";

export const VisibleRule = "visibleRule";

export const isVerifiable = "isVerifiable";

export const updatesNotAllowed = "updatesNotAllowed";

export const AcceptUntrustedCerts = "acceptUntrustedCerts";
